import React from "react";
import { Button, Form } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import "./Footer.css";

const Footer = () => {
    return (
        <div className="footer-bg">
            <div className="container">
                <div className="row g-4">
                    <div className="py-5 pt-5 pb-5 pb-0 col-sm-12 col-md-8 text-md-start">
                        <h1 className="fw-bold">
                            Let's <span className="text-danger">talk</span>
                        </h1>
                        <h6 className="text-secondary">
                            Get in touch via the form below, or by
                            emailing&nbsp;
                            <span className="text-warning">
                                aboutnaimur@gmail.com
                            </span>
                        </h6>
                        <Form className="mt-4">
                            <Form.Group className="mb-3">
                                <Form.Label>Your name:</Form.Label>
                                <Form.Control
                                    className="bg-dark border-0"
                                    type="email"
                                    placeholder="Enter your name"
                                />
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>Email address:</Form.Label>
                                <Form.Control
                                    className="bg-dark border-0"
                                    type="email"
                                    placeholder="Enter your email"
                                />
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>Message:</Form.Label>
                                <Form.Control
                                    className="bg-dark border-0"
                                    as="textarea"
                                    placeholder="Enter your message"
                                    rows={3}
                                />
                            </Form.Group>
                            <Button
                                type="submit"
                                variant="dark"
                                className="text-warning px-3 py-2 rounded-3"
                            >
                                Submit
                            </Button>
                        </Form>
                    </div>
                    <div className="col-sm-12 col-md-4 text-md-start px-5 pt-md-5 align-self-center">
                        <div>
                            <h4 className="fw-bold  mt-5">Explore</h4>
                            <div className="text-secondary explore-link ps-2">
                                <p>
                                    <NavLink to="/home">Home</NavLink>
                                </p>
                                <p>
                                    <NavLink to="/aboutme">About Me</NavLink>
                                </p>
                                <p>
                                    <NavLink to="/projects">Projects</NavLink>
                                </p>
                                <p>
                                    <NavLink to="/blogs">Blogs</NavLink>
                                </p>
                            </div>
                        </div>
                        <div>
                            <h4 className="fw-bold mt-4">Follow</h4>
                            <div className="icons">
                                <a
                                    target="_blank"
                                    rel="noreferrer"
                                    href="https://www.linkedin.com/in/naimurnemu/"
                                    className="rounded-circle icon-1"
                                >
                                    <i className="fab fa-linkedin-in" />
                                </a>
                                <a
                                    target="_blank"
                                    rel="noreferrer"
                                    href="https://github.com/naimurnemu"
                                    className="rounded-circle icon-2"
                                >
                                    <i className="fab fa-github" />
                                </a>
                                <a
                                    target="_blank"
                                    rel="noreferrer"
                                    href="https://twitter.com/naimurnemu"
                                    className="rounded-circle icon-3"
                                >
                                    <i className="fab fa-twitter" />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <hr className="mb-0" />
                <p className="text-secondary m-0 pb-3">
                    <small>&copy;2021 All Rights reserved by Naimur Rahman</small>
                </p>
            </div>
        </div>
    );
};

export default Footer;
